var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg035SgBenchmarkRates = function Svg035SgBenchmarkRates(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 412V100c0-22.091 17.909-40 40-40H60c-22.091 0-40 17.909-40 40v312c0 22.091 17.909 40 40 40h60c-22.091 0-40-17.909-40-40z",
    fill: "#a0eda2",
    "data-original": "#cee1f2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m332 136 80 80m0-80-80 80m0 80 80 80m0-80-80 80m4-316h116c22.091 0 40 17.909 40 40v312c0 22.091-17.909 40-40 40H60c-22.091 0-40-17.909-40-40V100c0-22.091 17.909-40 40-40h196m-156 76 80 80m0-80-80 80M256 20v472",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#005454",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#0023c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100 336 20 40 60-80",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#14d64d",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#ff5cf4"
  }));
};

export default Svg035SgBenchmarkRates;